import PagedResult from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/PagedResult";
import GenericCrudServiceV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/GenericCrudServiceV2";
import HttpClientV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/HttpClientV2";
import { Accomplishment } from "../models/Accomplishment";
import ApiResponseV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/ApiResponseV2";
import { RankedUser } from "../models/RankedUser";
import HttpClient from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/HttpClient";
import ApiResponse from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/ApiResponse";
import { RankingCategory } from "../utils/enums/RankingCategory";
import { AccomplishmentType } from "../models/AccomplishmentType";

class AccomplishmentService extends GenericCrudServiceV2<Accomplishment> {
  getMyAccomplishments(pageNumber: number, pageSize: number): Promise<ApiResponseV2<PagedResult<Accomplishment>>> {
    return HttpClientV2.get(`${this.basePath}/my-accomplishments?page=${pageNumber}&pageSize=${pageSize}`);
  }

  getAllAccomplishmentsByStatus(pageNumber: number, pageSize: number, status: string): Promise<ApiResponseV2<PagedResult<Accomplishment>>> {
    return HttpClientV2.get(`${this.basePath}/status?page=${pageNumber}&pageSize=${pageSize}&status=${status}`);
  }

  createAccomplishment(userId: string, accomplishment: Accomplishment): Promise<ApiResponse<Accomplishment>> {
    return HttpClient.post(`${this.basePath}/create?reporterId=${userId}`, accomplishment);
  }

  deleteAccomplishment(externalId: string): Promise<ApiResponseV2<Accomplishment>> {
    return HttpClientV2.delete(`${this.basePath}/${externalId}`);
  }

  updateAccomplishment(externalId: string, accomplishment: Accomplishment): Promise<ApiResponseV2<Accomplishment>> {
    return HttpClientV2.put(`${this.basePath}/${externalId}`, accomplishment);
  }
  updateStatus(externalId: string, status: string): Promise<ApiResponseV2<Accomplishment>> {
    return HttpClientV2.put(`${this.basePath}/status?externalId=${externalId}&status=${status}`, {});
  }

  getMonthlyTotalPoints(): Promise<ApiResponseV2<number>> {
    return HttpClientV2.get(`${this.basePath}/monthly-total-points`);
  }

  getMonthlyRanking(month: number, year: number, category: RankingCategory): Promise<ApiResponseV2<RankedUser[]>> {
    return HttpClientV2.get(`${this.basePath}/monthly-ranking?month=${month}&year=${year}&category=${category}`);
  }

  getTypes(): Promise<ApiResponseV2<AccomplishmentType[]>> {
    return HttpClientV2.get(`${this.basePath}/types`);
  }
}

export default new AccomplishmentService("/ensolvers-ops/accomplishment");
